var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 18,
    viewBox: "0 0 53 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8577 0.890625L11.4611 12.0115L9.68765 2.55322C9.46598 1.48177 8.65315 0.890625 7.72949 0.890625H0.524903L0.414062 1.37093C1.89193 1.70345 3.55452 2.2207 4.58903 2.7749C5.21712 3.10742 5.40185 3.40299 5.58658 4.21582L8.94872 17.258H13.4562L20.3283 0.890625H15.8577Z",
    fill: "#374694"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1388 0.890625L18.6289 17.258H22.8778L26.3507 0.890625H22.1388Z",
    fill: "#374694"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9294 5.43375C31.9294 4.84261 32.5205 4.21452 33.7397 4.06673C34.3309 3.99284 36.0304 3.91894 37.9147 4.80566L38.6536 1.33268C37.6191 0.963216 36.326 0.59375 34.7004 0.59375C30.5254 0.59375 27.5697 2.81055 27.5327 6.0249C27.4958 8.38948 29.6387 9.68261 31.2274 10.4585C32.89 11.2713 33.4442 11.7516 33.4072 12.4906C33.4072 13.5989 32.0771 14.0793 30.8949 14.0793C28.752 14.1162 27.5327 13.4881 26.5352 13.0447L25.7593 16.6286C26.7568 17.0719 28.5672 17.4783 30.4515 17.4783C34.8851 17.4783 37.8039 15.2985 37.8039 11.8625C37.8778 7.6136 31.8924 7.35497 31.9294 5.43375Z",
    fill: "#374694"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1582 11.4552L46.4119 5.3221L47.6681 11.4552H44.1582ZM45.7838 0.88851C44.971 0.88851 44.269 1.36881 43.9735 2.0708L37.6187 17.2189H42.0522L42.939 14.7804H48.3701L48.8874 17.2189H52.8037L49.4046 0.851562L45.7838 0.88851Z",
    fill: "#374694"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.c395a44afa6103438c736dd3cd2b7c1b.svg";
export { ForwardRef as ReactComponent };